// A database's queues as counts and ages (JOB-S4, lane SA): shared by a node's beacon view (fleet.nodes.health) and the
// cloud's ops.queues.health, in a file of its own so neither context imports the other.
import { z } from 'zod';

/**
 * A database's queues as counts and ages (JOB-S4, lane SA; server platform/jobs/queue-health.ts): its scheduler's newest
 * tick, the oldest due job no runner took, jobs failed in the last day (and how many of a critical kind), handlers parked
 * on an event they never processed, and the oldest outbox row not yet dispatched. Never a payload or an error text.
 */
export const QueueHealthView = z
  .object({
    schedulerTickAgeSeconds: z.number().nonnegative().nullable(),
    oldestDueJobSeconds: z.number().nonnegative().nullable(),
    failedJobsLast24h: z.int().nonnegative(),
    criticalFailedJobsLast24h: z.int().nonnegative(),
    parkedHandlers: z.int().nonnegative(),
    oldestParkedSeconds: z.number().nonnegative().nullable(),
    oldestUndispatchedOutboxSeconds: z.number().nonnegative().nullable(),
  })
  .meta({ id: 'QueueHealthView' });

